<ng-container
  [templateStore]="{
    isDone: (isDone$ | async)
  }"
  #tStore="templateStore"
>
  <matching-progress></matching-progress>
</ng-container>
